import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { SuperAgentThread } from "app/pages/sales-intelligence/modules/ai-agent/types/superAgent";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const useRecentAISearches = (): UseQueryResult<{ items: SuperAgentThread[] }> => {
    return useQuery({
        enabled: salesSettingsHelper.isSuperAgentEnabled,
        queryKey: aiAgentQueryKeys.superAgent.recents(),
        queryFn: ({ signal }) => {
            return salesApiService.aiAgent.superAgent.getSuperAgentThreads({ cancellation: signal });
        },
    });
};
